<template>
  <div class="webeo-wrapper">
    <div class="webeo-container">
      <div class="webeo-header">
        <img
          src="../assets/webeo-logo.png"
          alt="Webeo company logo"
        >
      </div>

      <div class="description">
        {{ $t('selectClient.description') }}
      </div>

      <el-form class="controls">
        <el-select
          v-model="clientId"
          filterable
          placeholder="Select Client"
          class="client-select"
        >
          <el-option
            v-for="client in filteredClients"
            :key="client.clientID"
            :label="client.name"
            :value="client.clientID"
          >
            {{ client.name }}
          </el-option>
        </el-select>

        <div class="toggles">
          <el-switch
            v-model="isActive"
            class="toggle"
            active-text="Active"
          />

          <el-switch
            v-model="isCustomer"
            class="toggle"
            active-text="Customer"
          />

          <el-switch
            v-model="demo"
            class="toggle"
            active-text="Demo"
          />
        </div>

        <div class="actions">
          <button
            class="login-button"
            data-test="login-submit"
            @click=" $event.preventDefault(); submitContinue();"
          >
            {{ $t('selectClient.continueButton') }}
          </button>

          <button
            class="logout-button"
            data-test="logout-submit"
            @click=" $event.preventDefault(); submitLogout();"
          >
            {{ $t('selectClient.logoutButton') }}
          </button>

          <div class="login-error">
            {{ errorMessage }}
          </div>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { required } from 'vuelidate/lib/validators';
import config from '../setup/config';
import axios from '../setup/axios';

export default {
  data: () => ({
    clients: [],
    clientId: null,
    errorMessage: null,
    isActive: true,
    isCustomer: true,
    demo: false,
  }),
  validations: {
    clientId: {
      required,
    },
  },
  computed: {
    filteredClients() {
      return this.clients
        .filter((x) => x.isActive === this.isActive)
        .filter((x) => x.isCustomer === this.isCustomer)
        .filter((x) => x.demo === this.demo);
    },
  },
  async created() {
    const result = await axios.get(`${config.microservices.client}/getallclients`);
    this.clients = result.data.clients
      .filter((x) => x.clientID > 2)
      .sort((a, b) => a.name.localeCompare(b.name));
  },
  methods: {
    ...mapActions(['logout', 'impersonate']),
    async submitContinue() {
      const success = await this.impersonate({ clientId: this.clientId });
      if (success) {
        const returnUrl = this.$route.query.ReturnUrl || '/';
        this.$router.push(returnUrl);
      }
    },
    submitLogout() {
      this.logout();
    },
  },
};
</script>

<style scoped>
.controls {
  display: flex;
  flex-direction: column;
}
.toggles {
  display: flex;
  flex-direction: column;
  margin-bottom: 5px;
}
.toggle {
  margin-bottom: 10px;
}
.webeo-wrapper {
  position: relative;
  top: 5%;
}
.webeo-container * {
  transition: 0.2s ease-in-out;
}
.webeo-container {
  width: 650px;
  box-sizing: border-box;
  border: 1px solid var(--webeo-grey100);
  margin: 0 auto;
  background-color: var(--webeo-white);
  padding: 0 75px 20px 75px;
}
.dark-theme .webeo-container {
  border: 1px solid var(--webeo-white);
  background-color: var(--webeo-background-2);
}
.webeo-header {
  padding: 30px 0px 20px 0px;
  display: flex;
  justify-content: center;
}
.webeo-header img {
  width: 200px;
  margin-right: 70px;
  margin-bottom: 20px;
}
.description {
  margin-bottom: 30px;
}
.client-select {
  width: 100%;
  margin-bottom: 20px;
}
.actions button {
  width: 100%;
  height: 40px;
  border-radius: 5px;
  margin-top: 10px;
  border: none;
  background-color: var(--webeo-magenta);
  color: var(--webeo-white);
  text-transform: uppercase;
  font-size: 16px;
  cursor: pointer;
}
.actions button:focus {
  outline: none;
}
.actions button:hover {
  background-color: var(--webeo-magenta-hover);
}
.actions button.logout-button {
  background-color: rgb(239, 239, 239);
  border: 1px solid var(--webeo-grey100);
  color: #000;
}
.actions button.logout-button:hover {
  background-color: var(--webeo-grey150);
  border: 1px solid var(--webeo-grey170);
}
.actions button.login-button:focus {
  outline: none;
}
.login-error {
  position: absolute;
  top: 100%;
  left: 0;
  display: inline-block;
  color: var(--webeo-error);
}
</style>

<style>
.client-select input {
  max-width: 100%;
}
</style>
